import React from "react";
import MetricsCard from "../../../../components/MetricsCard/MetricsCard";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

const MetricsOfRoutes = () => {
  const {
    listRoutes,
    listRoutesAssigned,
    routesCompleted,
    kmCompleted,
    totalOfRoutes,
  } = useSelector((state) => state.routeReducer);
  const { routeLimit } = useSelector((state) => state.membershipReducer);
  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: 5, width: "80%" }}>
      <MetricsCard
        title="Rutas Completadas"
        value={`${routesCompleted} de ${[...listRoutes, ...listRoutesAssigned].length}`}
        titleTooltip="Rutas que has completado"
      />
      <MetricsCard
        title="Rutas Creadas"
        value={`${totalOfRoutes} de ${routeLimit}`}
        titleTooltip="Total de rutas creadas con tu actual membresía."
      />
      <MetricsCard
        title="KM Recorrridos"
        value={`${kmCompleted} KM`}
        titleTooltip="Total de kilometros recorridos con Radaria."
      />
    </Box>
  );
};

export default MetricsOfRoutes;
